import { useEffect } from 'react'

import { PlusSignIcon, MinusSignIcon } from '@hugeicons/react'
import { useFormContext, useWatch } from 'react-hook-form'

import { Button } from '@/shared/ui/Button'
import { useResourceContext } from '@/shared/ui/Resource'

import { stepperAvailableQuantity } from '../../lib/stock'

export const DigitalProductStoreBottomSheetQuantityField = () => {
  const { reward_items } = useResourceContext()
  const { register, formState, setValue, getValues } = useFormContext()
  const { isSubmitting } = formState
  const quantity = useWatch({ name: 'quantity', defaultValue: 1 })
  const variation = useWatch({
    name: 'reward_item_id',
    defaultValue: ''
  })
  const selectedVariation = reward_items.find(item => item.id === variation)
  const { min_quantity, max_quantity } = selectedVariation || {}
  const availableQuantity = stepperAvailableQuantity(selectedVariation)

  const handleQuantity = operation => {
    if (isSubmitting) return

    const prev = getValues('quantity')
    if (!['increment', 'decrement'].includes(operation)) return

    if (operation === 'increment') {
      setValue('quantity', Math.min(prev + 1, max_quantity), {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true
      })
    } else if (operation === 'decrement') {
      setValue('quantity', Math.max(prev - 1, min_quantity), {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true
      })
    }
  }

  useEffect(() => {
    const newVariation = reward_items.find(item => item.id === variation)
    if (newVariation) {
      setValue('quantity', newVariation.min_quantity, {
        shouldValidate: true,
        shouldDirty: true,
        shouldTouch: true
      })
    }
  }, [variation])

  return (
    <div className="flex border border-gray-300 rounded-lg px-3">
      <div className="flex items-center content-center">
        <Button
          type="button"
          variant="ghost"
          icon
          size="sm"
          onClick={() => handleQuantity('decrement')}
          disabled={isSubmitting || !min_quantity || quantity == min_quantity}
          leadingIcon={<MinusSignIcon variant="solid" />}
          aria-label="Diminuir quantidade"
        />
      </div>
      <input
        type="number"
        {...register('quantity', { valueAsNumber: true, min: 1, max: 99 })}
        className="w-[45px] border-0 text-center text-xl font-bold p-1"
        readOnly
      />
      <div className="flex items-center content-center">
        <Button
          type="button"
          variant="ghost"
          icon
          size="sm"
          onClick={() => handleQuantity('increment')}
          disabled={
            isSubmitting || !max_quantity || quantity >= availableQuantity
          }
          leadingIcon={<PlusSignIcon variant="solid" />}
          aria-label="Aumentar quantidade"
        />
      </div>
    </div>
  )
}
